<template>
  <div
    v-if="article"
    class="s-full-article-container"
  >
    <div
      v-if="featuredImage"
      class="s-full-article-container__image"
    >
      <NuxtImg
        provider="imagekit"
        format="webp"
        :src="$correctedImageUrl(featuredImage).cleanUrl"
        :modifiers="{ q: 75 }"
        alt="article"
      />
    </div>
    <div class="s-full-article-container__text-wrapper w-full">
      <client-only>
        <SocialShareArticle
          :article="article"
          :content="content"
          :title="title"
        />
      </client-only>

      <div class="s-full-article-container__text-wrapper_article w-full break-words">
        <div class="title">{{ title }}</div>
        <div
          class="post"
          v-html="content"
        ></div>
      </div>
    </div>

    <ArticlePageRelatedArticles :posts="related" />
  </div>
</template>
<script>
  import { $api } from '@/utils/api'

  export default {
    props: {
      article: {
        type: Object,
        default: null
      }
    },

    data() {
      return {
        related: []
      }
    },

    computed: {
      content() {
        const newContent = this.replaceImgTags(this.article?.content?.rendered)
        return newContent || null
      },

      title() {
        return this?.article?.title?.rendered || null
      },

      featuredImage() {
        return this?.article?.acf?.featured_image?.url || null
      }
    },

    mounted() {
      this.$nextTick(async () => {
        // this.$nuxt.$loading.start()
        await Promise.all([this.getRandomPosts()])
        // this.$nuxt.$loading.finish()
      })
    },

    methods: {
      // async getArticleInfo() {
      //   const id = this.$route.query.id
      //
      //   try {
      //     const result = await $api.BlogRequests.getSinglePost(id);
      //     this.article = result.content.rendered;
      //     this.featured_image = result.acf.featured_image.url;
      //     this.title = result.title.rendered;
      //
      //   } catch (e) {
      //     console.log(e)
      //   }
      // },

      async getRandomPosts() {
        try {
          const related = await $api.BlogRequests.getRandomPosts()
          this.related = related
          // console.log(related, 'random');
        } catch (e) {
          // console.log(e)
        }
      },
      replaceImgTags(htmlContent) {
        // Define the regex pattern to match img tags
        const imgRegex = /<img\s+.*?src\s*=\s*["']([^"']+?)["'].*?>/g

        // Replace img tags with NuxtImg tags
        const replacedHtml = htmlContent.replace(imgRegex, (match, src) => {
          // Modify the src attribute to replace the domain and add format webp
          const imageUrl = src.replace('https://cdn.theflowery.co/', 'https://ik.imagekit.io/salve/')
          const nuxtImgTag = `<img src="${imageUrl}?tr=f-webp" alt="article" />`
          return nuxtImgTag
        })

        return replacedHtml
      }
    }
  }
</script>

<style lang="postcss">
  .s-full-article-container__text-wrapper_share-links {
    @apply flex flex-row md:flex-col text-center items-center text-sm font-bold;

    a {
      @apply block p-3 md:mt-1;
    }
  }
</style>

<style scoped lang="postcss">
  .s-full-article-container {
    @apply max-w-screen-lg mx-auto justify-center font-alt;

    &__image {
      img {
        @apply object-cover w-full h-full;
      }
    }

    &__text-wrapper {
      @apply inline-flex flex-col md:flex-row md:mt-10 p-5 md:p-0 border-b border-gray-200 mb-10;

      &_article {
        @apply md:ml-10;

        .title {
          @apply underline leading-tight block font-semibold text-3xl mb-5;
        }

        .post {
          :deep(p) {
            @apply mb-5;
          }

          :deep(.wp-block-image) {
            &.size-large {
              @apply w-full mt-1 mb-5;
            }

            .alignright {
              &.size-medium {
                @apply float-right mt-1 ml-6 mb-5;
              }

              &.size-full {
                @apply float-right mt-1 ml-6 mb-5;
              }
            }

            .alignleft {
              &.size-medium {
                @apply float-left mt-1 mr-6 mb-5;
              }

              &.size-full {
                @apply float-left mt-1 mr-6 mb-5;
              }
            }
          }

          :deep(.wp-block-gallery) {
            @apply grid gap-5 mb-5;

            &.columns-1 {
              @apply grid-cols-1;
            }

            &.columns-2 {
              @apply grid-cols-2;
            }

            &.columns-3 {
              @apply grid-cols-3;
            }

            &.columns-4 {
              @apply grid-cols-4;
            }

            &.columns-default {
              @apply grid-cols-4;
            }

            > .wp-block-image {
              @apply mb-0 mt-0;
            }
          }
        }
      }
    }
  }
</style>
